import { AAROH_IMAGES } from "./images.js";

export const navItems = [
  {
    label: "About",
    to: "/about",
    description: "Understand the mission, work and people behind Project GRID.",
    children: [
      { label: "About GRID", to: "/about", summary: "The idea, vision and mission." },
      { label: "Our journey", to: "/journey", summary: "How the initiative took shape." },
      { label: "Team", to: "/team", summary: "The people and working groups behind GRID." },
      { label: "Partnerships", to: "/partnerships", summary: "The organisations we work with, and their roles." },
      { label: "Impact", to: "/impact", summary: "2,013 participants across three programmes." },
      { label: "Media library", to: "/media", summary: "Official logos and photos." },
      { label: "Governance", to: "/governance", summary: "How trust is designed in." },
      { label: "Meeting archive", to: "/meetings", summary: "Conversations and visits connected to GRID." },
    ],
  },
  {
    label: "Programmes",
    to: "/programmes",
    description: "Explore the programmes GRID runs and supports.",
    children: [
      { label: "All programmes", to: "/programmes", summary: "See the complete programme model." },
      { label: "AAROH", to: "/programmes/aaroh", summary: "A GRID event built with Tachyon India and CiPD at IIIT Delhi." },
      { label: "Aurora", to: "/programmes/aurora", summary: "A global changemaking journey." },
      { label: "Metamorphosis", to: "/programmes/metamorphosis", summary: "GRID was the outreach partner." },
      { label: "Upcoming events", to: "/programmes/upcoming", summary: "Watch for confirmed future announcements." },
    ],
  },
  {
    label: "Opportunities",
    to: "/student-opportunities",
    description: "Connect as an organisation, join the GRID team or intern with us.",
    children: [
      { label: "Ways to connect", to: "/student-opportunities", summary: "Choose the route that fits you." },
      {
        label: "Connect as an organisation",
        to: "/student-opportunities/organisations",
        summary: "Schools, NGOs, institutions and companies.",
      },
      {
        label: "Join the team",
        to: "/student-opportunities/team",
        summary: "Build programmes, partnerships and community.",
      },
      {
        label: "Intern with GRID",
        to: "/student-opportunities/internships",
        summary: "Contribute through a scoped learning role.",
      },
    ],
  },
  {
    label: "Problems we help solve",
    to: "/problems",
    description: "See the challenges GRID helps young people understand and address.",
    children: [
      { label: "How GRID helps", to: "/problems", summary: "Understand our indirect role." },
      { label: "Education", to: "/problems/education", summary: "Learning access and participation." },
      { label: "Accessibility", to: "/problems/accessibility", summary: "Remove preventable barriers." },
      { label: "Climate", to: "/problems/climate", summary: "Adaptation, waste, water and energy." },
      { label: "Health", to: "/problems/health", summary: "Careful community health design." },
      { label: "Civic tech", to: "/problems/civic-tech", summary: "Make public systems easier to use." },
    ],
  },
];

export const fieldNotes = [
  {
    src: AAROH_IMAGES.studentSpeaker,
    alt: "A student speaking with a microphone during AAROH at IIIT Delhi",
    caption: "Student voices enter the room.",
  },
  {
    src: AAROH_IMAGES.buildSession,
    alt: "A mentor and students working together on laptops during AAROH",
    caption: "Learning by building together.",
  },
  {
    src: AAROH_IMAGES.studentPresentation,
    alt: "A student presenting from a lectern to the AAROH auditorium",
    caption: "Work becomes public.",
  },
  {
    src: "/images/grid-photo-06-p7.jpg",
    alt: "Project GRID founders Moksh Sindhwani and Tanishq Aggarwal",
    caption: "The people behind the projects.",
  },
  {
    src: "/images/grid-photo-07-p7.jpg",
    alt: "A large student cohort assembled outside a campus building",
    caption: "A cohort at scale.",
  },
];

export const buildSteps = [
  {
    key: "observe",
    number: "01",
    title: "Observe",
    body: "See the system, not only the symptom.",
  },
  {
    key: "question",
    number: "02",
    title: "Question",
    body: "Challenge assumptions with people who live the problem.",
  },
  {
    key: "design",
    number: "03",
    title: "Design",
    body: "Shape a response that can be tested early.",
  },
  {
    key: "build",
    number: "04",
    title: "Build",
    body: "Prototype with software, hardware, research or community action.",
  },
  {
    key: "impact",
    number: "05",
    title: "Impact",
    body: "Learn, improve and move useful work into the world.",
  },
];

export const programmes = [
  {
    slug: "aaroh",
    title: "AAROH",
    kicker: "Project GRID event",
    summary:
      "A two-day student-led innovation festival at IIIT-Delhi, bringing together 363 young innovators from across India and recognising 13 top teams.",
    image: AAROH_IMAGES.room,
    imageAlt: "Students working in teams across the AAROH auditorium at IIIT Delhi",
    audience: "Students in Classes 9-12, in teams of 1-3",
    focus: "Technology, entrepreneurship and a testable first prototype",
    model: "Think. Build. Launch.",
    status: "GRID event, built collaboratively",
    externalUrl: "https://www.aarohindia.com/",
    externalLabel: "AAROH official site",
  },
  {
    slug: "aurora",
    title: "Aurora",
    kicker: "Project GRID programme",
    summary:
      "A year-long global hackathon and changemaking festival for students in Grades 8-12, designed with remote and under-resourced learners in mind.",
    image: "/images/campaign/grid-campaign-11-aurora-winners.jpg",
    imageAlt: "Aurora winners holding their laptop prizes in a Project GRID campaign collage",
    audience: "Students in Grades 8-12",
    focus: "Inclusive innovation and low-bandwidth participation",
    model: "A year-long learning and building journey",
    status: "GRID programme",
    externalUrl: "https://aurora.projectgrid.org/",
    externalLabel: "Visit Aurora",
  },
  {
    slug: "metamorphosis",
    title: "Metamorphosis",
    kicker: "Project GRID · Outreach partner",
    summary:
      "Metamorphosis is led by the Tale of Humankind Foundation and IIT Delhi's Office of Academic Outreach & New Initiatives. Project GRID was the outreach partner.",
    image: "/images/campaign/grid-campaign-10-flagship.jpg",
    imageAlt: "A Project GRID speaker and student group in a blue and orange campaign collage",
    audience: "High-school students",
    focus: "Outreach and student participation",
    model: "Led by Tale of Humankind Foundation and IIT Delhi",
    status: "GRID role: outreach partner",
    externalUrl: "https://metamorphosis.taleofhumankind.org/",
    externalLabel: "Visit Metamorphosis",
  },
];

export const impactMetrics = [
  { value: "2,013", label: "Participants", note: "Across AAROH, Aurora and Metamorphosis" },
  { value: "27+", label: "Countries", note: "Aurora participants" },
  { value: "363", label: "Young innovators", note: "AAROH at IIIT Delhi, 1–2 August 2026" },
];

export const impactAchievements = [
  {
    slug: "aurora-global-hackathon-2026",
    eyebrow: "Completed · GRID organised",
    title: "Aurora Global Hackathon 2026",
    summary:
      "A public, student-only global hackathon for builders aged 14 and above. The programme moved teams from an idea round into prototypes, live pitches and incubation.",
    facts: ["1,500 participants", "27+ countries", "Top 20 entered incubation"],
    image: "/images/aurora/aurora-devpost-background.jpg",
    imageAlt: "Official Aurora Global Hackathon banner published on Devpost",
    sourceLabel: "Aurora on Devpost",
    sourceUrl: "https://aurora-global-hackathon-grid.devpost.com/",
  },
  {
    slug: "chillgui-overall-winner",
    eyebrow: "Student outcome · Overall winner",
    title: "ChillGui won Aurora",
    summary:
      "Jerovin Floyd Vincent Joseph built ChillGui, an Edge-AI accessibility project that simplifies everyday app interfaces for older users. It won Aurora overall.",
    facts: ["Solo builder", "Accessibility focus", "Winner laptop awarded"],
    image: "/images/grid-photo-10-p8.jpg",
    imageAlt: "Aurora overall winner Jerovin Floyd Vincent Joseph holding his laptop prize",
    sourceLabel: "Project GRID on LinkedIn",
    sourceUrl: "https://www.linkedin.com/company/project-grid-global",
    personSlug: "jerovin-floyd-vincent-joseph",
  },
  {
    slug: "metamorphosis-outreach",
    eyebrow: "Completed · GRID outreach partner",
    title: "Metamorphosis outreach",
    summary:
      "Metamorphosis was led by the Tale of Humankind Foundation and IIT Delhi's Office of Academic Outreach and New Initiatives. Project GRID was the outreach partner.",
    facts: ["150 students", "18 states", "1 week · 36 products"],
    image: "/images/grid-photo-01-p1.jpg",
    imageAlt: "Students gathered at Metamorphosis at IIT Delhi",
    sourceLabel: "Metamorphosis site",
    sourceUrl: "https://metamorphosis.taleofhumankind.org/",
  },
];

export const opportunityPaths = [
  {
    slug: "organisations",
    number: "01",
    title: "Connect as an organisation",
    body:
      "Schools, NGOs, institutions and companies can bring a real problem, expand access or build a clear pathway for young people.",
    image: AAROH_IMAGES.collaboration,
    to: "/partnerships",
    cta: "See partnership routes",
    promise: "Bring a problem, place or pathway that gives young builders a real context.",
    fits: ["Schools and colleges", "Nonprofits and community groups", "Research and public institutions", "Mission-aligned companies"],
    steps: ["Send a concise brief", "Define the role and ownership", "Agree the student-facing value", "Publish the relationship accurately"],
    emailSubject: "Organisation partnership with Project GRID",
  },
  {
    slug: "team",
    number: "02",
    title: "Join the GRID team",
    body:
      "Work across programmes, partnerships, operations, engineering, community or creative delivery with a named responsibility.",
    image: AAROH_IMAGES.studentTeam,
    to: "/team",
    cta: "Meet the team",
    promise: "Take responsibility for a real part of GRID and show the work you can own.",
    fits: ["Programme delivery", "Partnerships and outreach", "Engineering and systems", "Community and creative work"],
    steps: ["Choose a working group", "Show relevant work", "Propose a first contribution", "Agree a realistic commitment"],
    emailSubject: "Joining the Project GRID team",
  },
  {
    slug: "internships",
    number: "03",
    title: "Intern with GRID",
    body:
      "Register interest in a scoped learning role where you can contribute useful work and grow through real responsibility.",
    image: AAROH_IMAGES.studentPortrait,
    to: "/team",
    cta: "Understand the working groups",
    promise: "Learn through a scoped contribution with a clear output, owner and review point.",
    fits: ["Research and documentation", "Programme operations", "Design and content", "Technical prototyping"],
    steps: ["Share your learning goal", "Choose a bounded project", "Set an output and timeline", "Review the work with its owner"],
    emailSubject: "Project GRID internship interest",
  },
];

export const guides = [
  {
    slug: "find-a-real-world-problem",
    title: "How to find a real-world problem",
    summary: "Move from a broad concern to a specific need worth investigating.",
    readTime: "6 min",
    image: "/images/campaign/grid-campaign-02-community.jpg",
    outcome: "Leave with one specific problem, the people affected and the evidence you still need.",
    sections: [
      {
        title: "Start with friction, not an idea",
        body:
          "Notice moments where someone loses time, access, confidence, money or choice. A useful problem is usually visible in a repeated struggle, not in a brainstormed app category.",
        action:
          "For one day, record five moments when someone says this is difficult, confusing, slow or impossible.",
      },
      {
        title: "Choose a person and a place",
        body:
          "Replace broad groups such as students or citizens with a real person in a real setting. Context changes the problem. A student using a shared phone at home faces different constraints from a student in a computer lab.",
        action: "Write: A specific person experiences a specific difficulty in a specific place.",
      },
      {
        title: "Check that it repeats",
        body:
          "One frustrating moment may be an exception. Look for frequency, consequences and failed workarounds. Speak with at least three people close to the situation before treating your observation as a pattern.",
        action: "Ask what happens now, how often it happens and what people already do to cope.",
      },
      {
        title: "Separate evidence from assumptions",
        body:
          "Create two columns. Put what you observed or heard in evidence. Put your explanation of why it happens in assumptions. Your first research task is to test the assumptions with the highest risk.",
        action: "Circle the assumption that would make your project useless if it were wrong.",
      },
      {
        title: "Pick a problem you can reach",
        body:
          "You do not need to solve the whole system. Choose a part you can investigate safely, with people you can speak to and a setting where a small test is possible.",
        action: "Define one contribution your team could test within two weeks.",
      },
    ],
    example: {
      label: "Broad concern to useful problem",
      before: "Education is unequal.",
      after:
        "Students sharing one family phone miss assignment updates because school messages arrive across several separate groups.",
    },
    checklist: [
      "A real person or group is named",
      "The setting is specific",
      "The difficulty has been observed more than once",
      "Existing workarounds are understood",
      "A small research or testing path is available",
    ],
  },
  {
    slug: "write-a-problem-statement",
    title: "Write a useful problem statement",
    summary: "Describe the person, context and constraint before jumping to a solution.",
    readTime: "7 min",
    image: "/images/campaign/grid-campaign-01-speaker.jpg",
    outcome: "Leave with a one-sentence brief that guides research without locking your team into a solution.",
    sections: [
      {
        title: "Name the person",
        body:
          "A problem statement becomes useful when the team can picture who experiences it. Use a group only when its members genuinely share the same context and constraint.",
        action: "Replace users with a specific person or clearly bounded group.",
      },
      {
        title: "Describe the moment",
        body:
          "State when and where the problem appears. The same person may need a different response at home, in transit, in a classroom or during an emergency.",
        action: "Add the moment when the difficulty becomes visible.",
      },
      {
        title: "Explain the consequence",
        body:
          "Describe what the person cannot do, loses or risks because of the difficulty. Avoid dramatic claims that your evidence cannot support.",
        action: "Complete the sentence: This matters because it causes...",
      },
      {
        title: "Include the constraint",
        body:
          "Constraints make the brief realistic. Consider cost, language, bandwidth, time, trust, safety, ability, access to devices and existing rules.",
        action: "Name the constraint your response must respect.",
      },
      {
        title: "Remove the hidden solution",
        body:
          "If your statement says needs an app, platform or AI tool, you have already chosen the answer. Return to the need so different responses can compete.",
        action: "Delete product words and check whether the problem still makes sense.",
      },
    ],
    example: {
      label: "Weak statement to useful brief",
      before: "Students need an AI homework app.",
      after:
        "Students who share devices at home struggle to find assignment instructions before deadlines because updates are spread across several channels.",
    },
    checklist: [
      "The person is specific",
      "The context is visible",
      "The consequence is credible",
      "At least one real constraint is named",
      "No solution is hidden inside the statement",
    ],
  },
  {
    slug: "beginner-hackathon-guide",
    title: "Your first student hackathon",
    summary: "A practical guide to teams, scope, prototypes and presenting clearly.",
    readTime: "9 min",
    image: "/images/campaign/grid-campaign-05-builders.jpg",
    outcome: "Leave with a working team rhythm, a small build target and a presentation based on evidence.",
    sections: [
      {
        title: "Read the rules before ideating",
        body:
          "Confirm the theme, eligibility, team size, submission format, judging criteria, deadline and required links. A strong project can still fail if the submission is incomplete.",
        action: "Turn every requirement into a shared checklist before the first team call.",
      },
      {
        title: "Build a team with clear roles",
        body:
          "You need ownership more than titles. Assign one person to the problem and evidence, one to the prototype, one to the story and submission, and one to coordination when the team is large enough.",
        action: "Write one sentence describing what each person owns by the next check-in.",
      },
      {
        title: "Cut the scope early",
        body:
          "The best first prototype proves one important interaction or assumption. A smaller working response is stronger than a large unfinished platform.",
        action: "Choose the one moment your demo must make believable.",
      },
      {
        title: "Work in visible checkpoints",
        body:
          "Use short build cycles. At each checkpoint, show what exists, name the largest risk and decide the next test. Do not wait until the final hour to combine separate pieces.",
        action: "Schedule a working demo at the halfway point, even if it is rough.",
      },
      {
        title: "Submit before the deadline",
        body:
          "Export the video, test links, check permissions and upload an early complete version. Improve it only after a valid submission exists.",
        action: "Set an internal deadline at least two hours before the official cutoff.",
      },
    ],
    example: {
      label: "A useful hackathon scope",
      before: "Build a complete accessibility platform for every app.",
      after:
        "Demonstrate one simplified task flow that helps an older user complete a common phone action with fewer confusing choices.",
    },
    checklist: [
      "Rules and judging criteria are understood",
      "Every team member owns a clear outcome",
      "The demo proves one central idea",
      "A halfway integration check is scheduled",
      "Links, permissions and files are tested early",
    ],
  },
  {
    slug: "idea-to-prototype",
    title: "From idea to prototype",
    summary: "Choose the smallest version of an idea that can teach you something real.",
    readTime: "8 min",
    image: "/images/campaign/grid-campaign-03-makerspace.jpg",
    outcome: "Leave with a prototype designed to answer one risky question, not imitate a finished product.",
    sections: [
      {
        title: "Write the riskiest assumption",
        body:
          "Every idea depends on beliefs about the person, need and response. Find the assumption that could make the project irrelevant, unsafe or impossible if it were wrong.",
        action: "Write: We believe that... Then ask what evidence would change your mind.",
      },
      {
        title: "Choose what the prototype must teach",
        body:
          "A prototype is an experiment. Decide whether you need to test understanding, usefulness, behaviour, technical feasibility or willingness to participate.",
        action: "Complete: After this test, we should know whether...",
      },
      {
        title: "Use the lowest useful fidelity",
        body:
          "A conversation script, paper flow, clickable screen, role-play or single working function may be enough. Do not build infrastructure before the central interaction is credible.",
        action: "Pick the cheapest format that creates the behaviour you need to observe.",
      },
      {
        title: "Test with the right people",
        body:
          "Friends can find obvious bugs, but they cannot represent every user. Test with people close to the real context and explain clearly that the prototype is unfinished.",
        action: "Prepare three neutral questions and avoid telling people how the prototype should work.",
      },
      {
        title: "Decide what changes next",
        body:
          "Record what happened, not only what people said. Keep, change or stop each major assumption. A failed test is useful when it prevents a larger mistake.",
        action: "End the session with one evidence-led change for the next version.",
      },
    ],
    example: {
      label: "Prototype the question",
      before: "Spend two weeks building accounts, profiles and a dashboard.",
      after:
        "Use five linked screens to test whether a student can understand and complete the core task without instructions.",
    },
    checklist: [
      "One risky assumption is selected",
      "The learning goal is written before building",
      "The fidelity matches the question",
      "Testing uses neutral prompts",
      "The next decision is tied to observed evidence",
    ],
  },
  {
    slug: "pitch-a-student-project",
    title: "Pitch a student project",
    summary: "Show the need, the evidence, the work and the next honest step.",
    readTime: "5 min",
    image: "/images/campaign/grid-campaign-07-builder-profile.jpg",
    outcome: "Leave with a short, credible project story that makes the problem, proof and next step easy to understand.",
    sections: [
      {
        title: "Open with the real moment",
        body:
          "Start with the person and situation that made the problem visible. A concrete moment earns attention faster than a broad statistic or a claim that your project will change everything.",
        action: "Describe the problem in two sentences without naming your product.",
      },
      {
        title: "Show what you learned",
        body:
          "Share the interviews, observations, tests or sources that changed your understanding. Separate completed evidence from estimates and future goals.",
        action: "Choose the two strongest pieces of evidence behind your decision.",
      },
      {
        title: "Demonstrate one clear flow",
        body:
          "Do not tour every screen or component. Show the moment where the response helps a person do something differently, then explain why that choice matters.",
        action: "Build a demo path that can be shown in under ninety seconds.",
      },
      {
        title: "Credit the people behind it",
        body:
          "Name team members, mentors, communities, programme partners and sources accurately. Be precise about who organised, built, supported and tested the work.",
        action: "Add one credit slide with roles, sources and collaborators.",
      },
      {
        title: "End with an honest next step",
        body:
          "Ask for the next thing the project actually needs: access to users, technical advice, a pilot setting, feedback or time to test. Avoid pretending the prototype is already a finished solution.",
        action: "Finish with one specific request and one measure of progress.",
      },
    ],
    example: {
      label: "Claim to credible pitch",
      before: "Our revolutionary platform will transform education for millions.",
      after:
        "We tested a simpler assignment flow with five students who share devices. Four completed the task without help. Next, we need a teacher partner for a two-week classroom pilot.",
    },
    checklist: [
      "The problem is concrete before the product appears",
      "Claims are connected to evidence",
      "The demo shows one complete flow",
      "Contributors and sources are credited",
      "The final request is specific and realistic",
    ],
  },
];

export const problemCategories = [
  {
    slug: "education",
    title: "Education",
    summary: "Learning access, school participation and tools that work in real classrooms.",
    gridRole:
      "GRID helps students investigate learning barriers and test practical responses with schools and learners.",
    image: "/images/campaign/grid-campaign-06-cohort.jpg",
    scale: "251M",
    scaleLabel: "children and young people remained out of school globally in UNESCO's 2024 monitoring report",
    sourceName: "UNESCO Global Education Monitoring Report",
    sourceUrl: "https://www.unesco.org/reports/gem-report/en/2024-monitoringsdg4",
    stakes: [
      "Access is shaped by income, location, disability, language and conflict.",
      "Being enrolled does not guarantee that tools, teaching or information are usable.",
      "A response built without teachers and learners can create another layer of friction.",
    ],
    indirectHelp: [
      "Students investigate a specific learning barrier instead of treating education as one abstract problem.",
      "Programme work encourages low-bandwidth, classroom-aware and evidence-led prototypes.",
      "Schools and learners can give the context and feedback that make a student response more useful.",
    ],
    contribution: "Map one repeated learning barrier, document who experiences it and test a smaller response with the people affected.",
  },
  {
    slug: "accessibility",
    title: "Accessibility",
    summary: "Products, spaces and services that exclude people through preventable barriers.",
    gridRole: "GRID helps young builders design with excluded users, not only for them.",
    image: "/images/grid-photo-10-p8.jpg",
    scale: "1.3B",
    scaleLabel: "people experience significant disability, around 16% of the global population",
    sourceName: "World Health Organization",
    sourceUrl: "https://www.who.int/en/news-room/fact-sheets/detail/disability-and-health",
    stakes: [
      "Barriers often come from products, transport, information and services rather than a person's condition.",
      "Accessibility added at the end is usually weaker than participation from the beginning.",
      "One excluded user group cannot stand in for every disability or context.",
    ],
    indirectHelp: [
      "GRID asks teams to involve people close to the barrier before choosing a response.",
      "Aurora created a route for accessibility-focused work such as ChillGui to be built and presented.",
      "Mentors and testing help students move from good intentions to more usable prototypes.",
    ],
    contribution: "Choose one task that is unnecessarily difficult, observe where exclusion happens and test with people who experience that barrier.",
  },
  {
    slug: "climate",
    title: "Climate",
    summary: "Local adaptation, waste, water, energy and better environmental decisions.",
    gridRole:
      "GRID helps teams turn local environmental concerns into small, evidence-led tests.",
    image: "/images/campaign/grid-campaign-03-makerspace.jpg",
    scale: "1.1B",
    scaleLabel: "children are exposed to at least three overlapping climate hazards, according to UNICEF's 2026 report",
    sourceName: "UNICEF Children’s Climate Risk Report 2026",
    sourceUrl: "https://www.unicef.org/press-releases/nearly-half-worlds-children-exposed-least-three-overlapping-climate-threats-unicef",
    stakes: [
      "Climate risk appears locally through heat, flooding, air, water, waste and disrupted services.",
      "The people least responsible can face the greatest exposure and the fewest resources.",
      "A prototype must not substitute for policy, infrastructure or expert environmental work.",
    ],
    indirectHelp: [
      "GRID gives students a way to translate a local environmental concern into a researchable question.",
      "Teams can prototype monitoring, communication or behaviour-support tools at a responsible scale.",
      "Programme feedback helps separate measurable contributions from claims of solving climate change.",
    ],
    contribution: "Start with one local hazard or resource flow, identify who is affected and measure a change small enough to test.",
  },
  {
    slug: "health",
    title: "Health",
    summary: "Access, awareness and community health challenges that require careful design.",
    gridRole:
      "GRID helps students research carefully, work with informed adults and avoid unsafe assumptions.",
    image: "/images/campaign/grid-campaign-01-speaker.jpg",
    scale: "1 in 7",
    scaleLabel: "young people aged 10-19 experience a mental health condition globally",
    sourceName: "World Health Organization",
    sourceUrl: "https://www.who.int/news-room/fact-sheets/detail/adolescent-mental-health",
    stakes: [
      "Health problems can involve safety, privacy, stigma and clinical knowledge.",
      "A student project should never present itself as diagnosis or treatment.",
      "Trust and safeguarding matter as much as the interface or technology.",
    ],
    indirectHelp: [
      "GRID can help teams frame health-related problems with clear safety boundaries.",
      "Students are encouraged to consult informed adults and credible evidence before building.",
      "Projects can focus on access, awareness and supportive information without making clinical claims.",
    ],
    contribution: "Work on a non-clinical access or information gap, define the safety boundary and involve an informed adult before testing.",
  },
  {
    slug: "civic-tech",
    title: "Civic tech",
    summary: "Make public information, services and participation easier to understand and use.",
    gridRole:
      "GRID helps young people make public information and participation easier to understand.",
    image: "/images/campaign/grid-campaign-07-builder-profile.jpg",
    scale: "800M",
    scaleLabel: "people lack official identification, limiting access to services and opportunities",
    sourceName: "World Bank ID4D Global Dataset",
    sourceUrl: "https://id4d.worldbank.org/global-dataset",
    stakes: [
      "Public systems can exclude through language, identity, connectivity, process and poor information design.",
      "Digitising a confusing process does not automatically make it fair or usable.",
      "Civic work requires care with privacy, security and the authority behind information.",
    ],
    indirectHelp: [
      "GRID helps students map a public-information or participation journey from the user's point of view.",
      "Teams can test clearer explanations, service navigation and feedback tools at a small scale.",
      "Programme review encourages accuracy, accessibility and privacy before public use.",
    ],
    contribution: "Take one public process, identify the point where people get lost and test a clearer path using verified information.",
  },
];

export const stories = [
  {
    slug: "what-is-project-grid",
    title: "What is Project GRID?",
    summary: "The belief, model and people behind a youth-led innovation ecosystem.",
    image: "/images/campaign/grid-campaign-04-founders.jpg",
    date: "July 2026",
  },
  {
    slug: "learning-by-building",
    title: "Learning by building",
    summary: "Field notes from the rooms, tools and conversations behind the work.",
    image: "/images/campaign/grid-campaign-03-makerspace.jpg",
    date: "July 2026",
  },
];

export const coreTeamGroups = [
  {
    label: "Founding board",
    members: [
      {
        name: "Moksh Sindhwani",
        role: "Co-Founder, CEO",
        photo: "/images/team/moksh-sindhwani.jpg",
        linkedin: "https://www.linkedin.com/in/moksh-sindhwani-760306349/",
      },
      {
        name: "Tanishq Aggarwal",
        role: "Co-Founder, CTO",
        photo: "/images/team/tanishq-aggarwal.jpg",
        linkedin: "https://www.linkedin.com/in/tanishq-aggarwal-/",
      },
      {
        name: "Harsh Jain",
        role: "Chief Community Officer, CCO",
        photo: "/images/team/harsh-jain.jpg",
        linkedin: "https://www.linkedin.com/in/harsh-ceo/",
      },
      { name: "Yash Varshney", role: "Founding Member, CGO", linkedin: "https://www.linkedin.com/in/yashvvarshney/" },
    ],
  },
  {
    label: "Partnerships",
    members: [
      {
        name: "Arav Bansal",
        role: "Director of Partnerships; Programme President, Aurora & AAROH",
      },
      { name: "Vivaan Jain", role: "Head, Partnerships" },
    ],
  },
  {
    label: "Engineering & technology",
    members: [
      {
        name: "Mihishkaa Sinha",
        role: "Director of Engineering; Programme President, AAROH",
      },
      { name: "Krishna Sapru", role: "Director, Technology" },
    ],
  },
  {
    label: "Outreach",
    members: [
      { name: "Reyaansh", role: "Director, Outreach & Corporate Affairs" },
    ],
  },
  {
    label: "Community",
    members: [
      { name: "Ninad Roi", role: "Director, Community" },
      { name: "Manan Sharma", role: "Head, Community" },
      { name: "Neeladri", role: "Co-Head, Community" },
    ],
  },
  {
    label: "Graphics & content",
    members: [
      { name: "Tranav Tyagi", role: "Director of Graphics" },
      { name: "Tanisha", role: "Head, Graphics" },
      { name: "Lyanna", role: "Head, Graphics" },
      { name: "Jennifer", role: "Associate Head, Content Creation" },
    ],
  },
];

export const verifiedPartnerRelationships = [
  {
    name: "Tale of Humankind Foundation",
    role: "Metamorphosis organiser",
    description:
      "Led the Metamorphosis initiative alongside IIT Delhi's Office of Academic Outreach & New Initiatives.",
    logo: "/images/partners/tale-of-humankind.webp",
    logoWidth: 1600,
    logoHeight: 1600,
    website: "https://taleofhumankind.org/",
  },
  {
    name: "IIT Delhi · Office of Academic Outreach & New Initiatives",
    role: "Metamorphosis organiser",
    description:
      "Institutional organiser of Metamorphosis, the student changemaking initiative supported by GRID through outreach.",
    logo: "/images/partners/iit-delhi-aoni.png",
    logoWidth: 1600,
    logoHeight: 1200,
    website: "https://academicoutreach.iitd.ac.in/",
  },
];

export const aarohCollaborators = [
  {
    name: "Project GRID",
    role: "AAROH event team",
    description:
      "Project GRID brings its youth innovation ecosystem, programme leadership and student pathways to AAROH.",
    logos: ["/images/grid-logo-original.png"],
    website: "/about",
    internal: true,
  },
  {
    name: "Tachyon India",
    role: "AAROH collaborator",
    description:
      "Tachyon India brings experience building direct-entry, innovation-driven hackathons for young developers, designers and creators.",
    logos: ["/images/partners/tachyon-india.png"],
    website: "https://www.tachyonindia.org/",
  },
  {
    name: "CiPD at IIIT Delhi",
    role: "AAROH institutional collaborator",
    description:
      "CiPD is the Centre for Intelligent Product Development at IIIT Delhi, focused on moving ideas and academic research toward production-ready hardware.",
    logos: ["/images/partners/cipd-iiitd.png", "/images/partners/iiit-delhi.png"],
    website: "https://cipd.iiitd.ac.in/",
  },
];

export const people = [
  {
    slug: "moksh-sindhwani",
    name: "Moksh Sindhwani",
    role: "Co-founder",
    image: "/images/grid-photo-06-p7.jpg",
    objectPosition: "62% center",
    connection: "Co-founded Project GRID",
    summary:
      "Moksh co-founded Project GRID with Tanishq Aggarwal after their experience at the Young Changemakers Bootcamp at IIT Delhi.",
    story:
      "Moksh is one of the two young builders behind Project GRID. He shares its belief that age should not be a barrier to innovation.",
    highlights: ["Project GRID co-founder", "Youth-led innovation", "Programme building"],
    gallery: [
      { src: "/images/grid-photo-06-p7.jpg", caption: "Moksh and Tanishq during Metamorphosis." },
      { src: "/images/grid-photo-09-p8.jpg", caption: "Builders together inside the manufacturing facility." },
    ],
    sourceLabel: "Project GRID on LinkedIn",
    sourceUrl: "https://www.linkedin.com/company/project-grid-global",
  },
  {
    slug: "tanishq-aggarwal",
    name: "Tanishq Aggarwal",
    role: "Co-founder",
    image: "/images/grid-photo-06-p7.jpg",
    objectPosition: "38% center",
    connection: "Co-founded Project GRID",
    summary:
      "Tanishq co-founded Project GRID with Moksh Sindhwani after their experience at the Young Changemakers Bootcamp at IIT Delhi.",
    story:
      "Tanishq works across GRID's programmes, its student-facing work and the Aurora Global Hackathon.",
    highlights: ["Project GRID co-founder", "Aurora organiser", "Youth public-impact work"],
    gallery: [
      { src: "/images/grid-photo-06-p7.jpg", caption: "Tanishq and Moksh during Metamorphosis." },
      { src: "/images/grid-photo-02-p7.jpg", caption: "Opening the room to questions during Metamorphosis." },
    ],
    sourceLabel: "Project GRID on LinkedIn",
    sourceUrl: "https://www.linkedin.com/company/project-grid-global",
  },
  {
    slug: "jerovin-floyd-vincent-joseph",
    name: "Jerovin Floyd Vincent Joseph",
    role: "Aurora 2026 · Overall winner",
    image: "/images/grid-photo-10-p8.jpg",
    objectPosition: "center center",
    connection: "Built ChillGui for Aurora",
    summary:
      "Jerovin, a student at IIIT Delhi, won Aurora Global Hackathon 2026 with ChillGui, an accessibility-focused app simplification project.",
    story:
      "His project began with a familiar problem: helping older family members use everyday smartphone apps. He turned that observation into an Edge-AI interface layer designed to make common tasks easier to navigate.",
    highlights: ["Aurora overall winner", "ChillGui", "Accessibility and Edge AI"],
    gallery: [
      { src: "/images/grid-photo-10-p8.jpg", caption: "Jerovin with his Aurora winner laptop." },
      { src: "/images/evidence/aurora-winner-01.jpg", caption: "The ChillGui project mark." },
      { src: "/images/evidence/aurora-winner-02.jpg", caption: "Aurora overall-winner certificate." },
    ],
    sourceLabel: "Project GRID on LinkedIn",
    sourceUrl: "https://www.linkedin.com/company/project-grid-global",
  },
  {
    slug: "gantavya-rohilla",
    name: "Gantavya Rohilla",
    role: "Aurora 2026 · Best Innovation",
    image: "/images/grid-photo-11-p8.jpg",
    objectPosition: "center center",
    connection: "Built a handwriting and spatial-computing concept for Aurora",
    summary:
      "Gantavya, a third-year student at IIT Madras, received Aurora's Best Innovation award for a personalised handwriting system designed to move note-taking into physical space.",
    story:
      "He built a custom handwriting-imitation model that learns a user's writing style and performs calculations. He is exploring smart-glasses integration.",
    highlights: ["Best Innovation", "Personalised handwriting model", "Smart-glasses direction"],
    gallery: [
      { src: "/images/grid-photo-11-p8.jpg", caption: "Gantavya with his Aurora prize laptop." },
      { src: "/images/aurora/aurora-devpost-cover.jpg", caption: "Aurora's official Devpost mark." },
    ],
    sourceLabel: "Project GRID on LinkedIn",
    sourceUrl: "https://www.linkedin.com/company/project-grid-global",
  },
];

export const peopleMet = [
  {
    slug: "ajai-chowdhry",
    name: "Ajai Chowdhry",
    role: "Co-Founder, HCL",
    context: "A conversation about innovation and the responsibility of young builders.",
    image: "/images/people-met/DamvNL9yFYV.jpg",
    sourceUrl: "https://www.instagram.com/p/DamvNL9yFYV/",
    date: "10 July 2026",
  },
  {
    slug: "ministry-innovation-cell",
    name: "Ministry of Education's Innovation Cell",
    role: "Institutional visit",
    context: "A visit to AICTE and the Ministry of Education's Innovation Cell focused on student innovation.",
    image: "/images/people-met/Damu65hSuq4.jpg",
    sourceUrl: "https://www.instagram.com/p/Damu65hSuq4/",
    date: "10 July 2026",
  },
  {
    slug: "sir-ganga-ram-hospital",
    name: "Chairman, Sir Ganga Ram Hospital",
    role: "Healthcare innovation conversation",
    context: "A discussion and presentation on youth-led healthcare innovation and technology development.",
    image: "/images/people-met/DamurCcyX6R.jpg",
    sourceUrl: "https://www.instagram.com/p/DamurCcyX6R/",
    date: "10 July 2026",
  },
  {
    slug: "cbse-skill-education",
    name: "Director, Skill Education at CBSE",
    role: "Product-development guidance",
    context: "A conversation that challenged how the team approached product development and innovation.",
    image: "/images/people-met/DamuPaKSA0J.jpg",
    sourceUrl: "https://www.instagram.com/p/DamuPaKSA0J/",
    date: "10 July 2026",
  },
  {
    slug: "metamorphosis-cohort",
    name: "Metamorphosis student cohort",
    role: "150 young builders",
    context: "A week of student problem-finding and product building at the Metamorphosis programme.",
    image: "/images/people-met/DamsytGmWmH.jpg",
    sourceUrl: "https://www.instagram.com/p/DamsytGmWmH/",
    date: "10 July 2026",
  },
];

export { sitemapPaths } from "./routes.js";
